<template>
  <div class="flex">
    <div
      v-show="showFullSearch"
      class="search-full-container w-full h-full absolute left-0 top-0"
      :class="{ flex: showFullSearch }"
    >
      <vx-auto-suggest
        ref="navbarSearch"
        :auto-focus="showFullSearch"
        :data="filterData"
        search_key="title"
        background-overlay
        class="w-full"
        input-classses="w-full vs-input-no-border vs-input-no-shdow-focus"
        icon="search"
        placeholder="Suchen..."
        @input="hnd_search_query_update"
        @selected="selected"
        @closeSearchbar="showFullSearch = false"
      >
        <template v-slot:group="{ group_name }">
          <p class="font-semibold text-primary">
            {{ group_name | title }}
          </p>
        </template>

        <!-- Pages Suggestion -->
        <template v-slot:pages="{ suggestion }">
          <div class="flex items-end leading-none py-1">
            <feather-icon
              :icon="suggestion.icon"
              svg-classes="h-5 w-5"
              class="mr-4"
            />
            <span class="mt-1">{{ suggestion.title }}</span>
          </div>
        </template>

        <!-- Pages Suggestion -->
        <template v-slot:applicants="{ suggestion }">
          <div class="flex items-end leading-none py-1">
            <span class="mt-1"
              >{{ suggestion.firstName }} {{ suggestion.lastName }}</span
            >
          </div>
        </template>

        <!-- No Items Slot -->
        <template v-slot:noResult>
          <div class="flex items-center">
            <feather-icon icon="InfoIcon" svg-classes="h-5 w-5" class="mr-4" />
            <span>Keine Ergebnisse gefunden.</span>
          </div>
        </template>
      </vx-auto-suggest>

      <div class="absolute right-0 h-full z-50 text-black">
        <feather-icon
          icon="times"
          class="px-4 cursor-pointer h-full close-search-icon"
          @click="showFullSearch = false"
        />
      </div>
    </div>
    <feather-icon
      icon="search"
      class="cursor-pointer navbar-fuzzy-search mr-20"
      @click="showFullSearch = true"
    />
  </div>
</template>

<script>
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import gql from "graphql-tag";

export default {
  components: {
    VxAutoSuggest
  },
  filters: {
    title(val) {
      return {
        pages: "Seiten",
        applicants: "Bewerber"
      }[val];
    }
  },
  data() {
    return {
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      showFullSearch: false,
      searchQuery: null
    };
  },
  computed: {
    filterData() {
      return {
        applicants: {
          key: "id",
          externalFilter: true,
          data: this.applicantsPage ? this.applicantsPage.results : []
        },
        ...this.navbarSearchAndPinList
      };
    }
  },
  apollo: {
    // TODO: Only call if searching for something
    applicantsPage: {
      query: gql`
        query ApplicantsPage(
          $page: Int!
          $size: Int
          $filter: ApplicantFilter
        ) {
          applicantsPage(page: $page, size: $size, filter: $filter) {
            total
            results {
              id
              number
              firstName
              lastName
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.searchQuery;
      },
      result() {
        this.$nextTick(() => {
          this.$refs.navbarSearch.updateSuggestions();
        });
      },
      variables() {
        return {
          page: 1,
          size: 5,
          filter: {
            fullTextSearch: this.searchQuery
          }
        };
      }
    }
  },
  methods: {
    selected(item) {
      let url;
      if (item.applicants) {
        url = this.$router.resolve({
          name: "applicant.show",
          params: {
            id: item.applicants.id
          }
        });
      } else if (item.pages) {
        url = this.$router.resolve(item.pages.url);
      }

      if (url) {
        window.location = url.href;
      }

      this.showFullSearch = false;
    },
    hnd_search_query_update(query) {
      // Show overlay if any character is entered
      this.$store.commit("TOGGLE_CONTENT_OVERLAY", !!query);
      if (query) {
        this.searchQuery = query;
      }
    }
  }
};
</script>
